import { render, staticRenderFns } from "./AuthenticationLayout.vue?vue&type=template&id=525b7ae0&scoped=true&"
import script from "./AuthenticationLayout.vue?vue&type=script&lang=ts&"
export * from "./AuthenticationLayout.vue?vue&type=script&lang=ts&"
import style0 from "./AuthenticationLayout.vue?vue&type=style&index=0&id=525b7ae0&scoped=true&lang=scss&"
import style1 from "./AuthenticationLayout.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "525b7ae0",
  null
  
)

export default component.exports